import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useBarIndicatorsColors } from '@/composables/useBarIndicatorsColors';
import { Palette } from '@/themes/themeOverrides/Palette';
import { formatNumber } from '@/helpers/format/formatNumber.js';
import { getActiveBarIndex, toBarSegments } from '@/helpers/analytics/charts.js';
import { styled } from '@mui/material/styles';
import { analyticsStyles } from '@/themes/commonStyles/analytics';

const colorGray = Palette.gray.gray300;

const StyledAnalyticsVerticalBars = styled(Box)(() => analyticsStyles.horizontalBars);

const ContractorAvgTransactionsField = ({ record, className, onClick }) => {
    const dailyTransactionsCount = record?.dailyTransactionsCount ?? 0;
    const transactionsNumber = formatNumber(dailyTransactionsCount, 0);
    const transactionsAvg = record?.dailyTransactionsAvg ?? 0;
    const transactionsStdDev = record?.dailyTransactionsStdDev ?? 0;

    const breakpoints = [transactionsAvg - transactionsStdDev, transactionsAvg, transactionsAvg + transactionsStdDev];
    const barColors = useBarIndicatorsColors(transactionsNumber, breakpoints, true);
    const activeBarIndex = getActiveBarIndex(transactionsNumber, breakpoints);
    const barSegments = toBarSegments(barColors);

    return (
        <StyledAnalyticsVerticalBars className={className}>
            <Box onClick={onClick} className='bars-wrapper'>
                {barSegments.map((segment, barPosition) => (
                    <Box
                        key={segment.key}
                        className='bar'
                        sx={{
                            backgroundColor: barPosition === activeBarIndex ? segment.color : colorGray,
                        }}
                    />
                ))}
            </Box>
            <Box className='text-wrapper'>
                <Box onClick={onClick} className='text-number'>
                    {formatNumber(dailyTransactionsCount, 2)}
                </Box>
            </Box>
        </StyledAnalyticsVerticalBars>
    );
};

ContractorAvgTransactionsField.propTypes = {
    record: PropTypes.shape({
        dailyTransactionsCount: PropTypes.number,
        dailyTransactionsAvg: PropTypes.number,
        dailyTransactionsStdDev: PropTypes.number,
    }),
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export default ContractorAvgTransactionsField;
